import { render, staticRenderFns } from "./superiorAssessmentFormList.vue?vue&type=template&id=f1907446&"
import script from "./superiorAssessmentFormList.vue?vue&type=script&lang=js&"
export * from "./superiorAssessmentFormList.vue?vue&type=script&lang=js&"
import style0 from "./superiorAssessmentFormList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports